export default __webpack_public_path__ + "static/media/pinterest.49ca89a8.png";